export default "__VITE_ASSET__44ff9d87__"